/* eslint-disable no-bitwise, operator-assignment -- a PRNG is inherently bitwise */

/**
 * Deterministic PRNG (mulberry32) that advances a numeric state field in place,
 * so the engine stays a pure function of (state, input, dt) with no `Math.random`
 * and a full run replays identically in tests from a given seed.
 */
export const nextRandom = (state: { rngState: number }): number => {
  const a = (state.rngState + 0x6d2b79f5) | 0;
  state.rngState = a;
  let t = Math.imul(a ^ (a >>> 15), 1 | a);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};
